/* Warenkorb am Handy (unter 768 px).
   1) Legt ein Kunde einen Wein in den Warenkorb, öffnet sich NICHT die Seitenleiste, sondern es erscheint ein kurzer
      schwebender Hinweis unten mittig (Flasche, Name, Summe) mit „Warenkorb ansehen“ und einem kleinen ×. Erst „Warenkorb ansehen“ (oder das
      Warenkorb-Symbol / die Bubble) öffnet die volle Seitenleiste mit allen Angaben, Häkchen und Kasse.
      Am Handy gilt das für jeden Kauf, am PC nur für Käufe aus einer Weinkarte in Listen (quick-add-to-cart);
      auf der Produktseite öffnet sich die Leiste am PC wie gewohnt.
   2) Die volle Seitenleiste legt beim Öffnen einen Verlaufseintrag an: Die Zurück-Taste schließt sie, statt die Seite
      zu verlassen. Der Lauscher läuft im Capture und stoppt das popstate, damit component-facets.js nicht reagiert
      (gleiches Muster wie das Filter-Fenster in sortiment-filter.js).
   3) Nur am PC (ab 768 px): goldene Bubble mit Korb-Symbol (wie auf den Kaufknöpfen der Weinkarte) und Zahl über dem Nach-oben-Pfeil (#go-top, Hersteller) öffnet die
      Warenkorb-Leiste. Sie sitzt IM Pfeil, erscheint also zusammen mit ihm (nach dem Scrollen) und folgt seiner Lage
      (shop-stickybar hebt ihn an). Die Zahl ist ein `data-header-cart-count`, das Theme hält sie damit selbst aktuell;
      bei 0 Flaschen ist die Bubble schwarz und ohne Zahl.
   4) „Noch eine Flasche dazu?“ (`cart-recommendations`) wird aus dem scrollenden Mittelteil direkt über den Fuß verschoben:
      So steht der schmale Streifen unten angedockt, die Weine scrollen darüber.
   Gestaltung: assets/warenkorb-blatt.css. */
(function () {
  'use strict';

  const leiste = document.getElementById('site-cart-sidebar');
  if ( ! leiste ) return;

  const handy = window.matchMedia('(max-width: 767px)');
  let imVerlauf = false;
  let eigenesZurueck = false;
  let offen = false;

  /* 2) Zurück-Taste */
  window.addEventListener('popstate', (event) => {
    if ( eigenesZurueck ) {
      eigenesZurueck = false;
      event.stopImmediatePropagation();
      return;
    }
    if ( ! imVerlauf ) return;
    imVerlauf = false;
    event.stopImmediatePropagation();
    if ( typeof leiste.hide === 'function' ) leiste.hide();
  }, true);

  new MutationObserver(() => {
    const jetztOffen = leiste.classList.contains('sidebar--opened');
    if ( jetztOffen === offen ) return;
    offen = jetztOffen;
    if ( offen ) {
      if ( ! handy.matches ) return;
      hinweisSchliessen();
      history.pushState({ ...( history.state || {} ), afpWarenkorb: true }, '', window.location.href);
      imVerlauf = true;
    } else if ( imVerlauf ) {
      imVerlauf = false;
      eigenesZurueck = true;
      history.back();
    }
  }).observe(leiste, { attributes: true, attributeFilter: ['class'] });

  /* 1) Hinweis statt Seitenleiste nach „In den Warenkorb“ */
  let hinweis = null;
  let uhr = 0;
  let vonKauf = false;
  let variante = '';

  function hinweisSchliessen() {
    clearTimeout(uhr);
    if ( hinweis ) hinweis.classList.remove('afp-wk-hinweis--offen');
  }

  function hinweisBauen() {
    hinweis = document.createElement('div');
    hinweis.className = 'afp-wk-hinweis';
    hinweis.setAttribute('role', 'status');
    hinweis.innerHTML =
      '<div class="afp-wk-hinweis__kopf">' +
        '<img class="afp-wk-hinweis__bild" alt="" width="56" height="56" hidden>' +
        '<div class="afp-wk-hinweis__text">' +
          '<span class="afp-wk-hinweis__titel">Zum Warenkorb hinzugefügt</span>' +
          '<span class="afp-wk-hinweis__wein"></span>' +
          '<span class="afp-wk-hinweis__summe"></span>' +
        '</div>' +
      '</div>' +
      '<div class="afp-wk-hinweis__knoepfe">' +
        '<button type="button" class="afp-wk-hinweis__ansehen">Warenkorb ansehen</button>' +
      '</div>' +
      '<button type="button" class="afp-wk-hinweis__zu" aria-label="Hinweis schließen">&times;</button>';
    document.body.appendChild(hinweis);
    hinweis.querySelector('.afp-wk-hinweis__zu').addEventListener('click', hinweisSchliessen);
    hinweis.querySelector('.afp-wk-hinweis__ansehen').addEventListener('click', () => {
      hinweisSchliessen();
      originalShow.call(leiste);
    });
  }

  function hinweisZeigen() {
    if ( ! hinweis ) hinweisBauen();
    const zeile = variante ? document.getElementById('item-' + variante) : null;
    const wein = hinweis.querySelector('.afp-wk-hinweis__wein');
    const bild = hinweis.querySelector('.afp-wk-hinweis__bild');
    const summe = hinweis.querySelector('.afp-wk-hinweis__summe');
    const vorlage = zeile ? zeile.querySelector('.afp-cart-weingut') : null;
    const name = zeile ? ( zeile.getAttribute('data-title') || '' ) : '';
    wein.textContent = ( vorlage ? vorlage.textContent.trim() + ' · ' : '' ) + name;
    wein.hidden = ! wein.textContent;
    const foto = zeile ? zeile.querySelector('.cart-item__thumbnail img') : null;
    if ( foto && ( foto.currentSrc || foto.src ) ) {
      bild.src = foto.currentSrc || foto.src;
      bild.hidden = false;
    } else {
      bild.hidden = true;
    }
    const anzahl = document.querySelector('#AjaxCartForm [data-cart-count]');
    const gesamt = document.querySelector('#AjaxCartForm [data-cart-total]');
    const n = anzahl ? parseInt(anzahl.textContent, 10) : NaN;
    summe.textContent = ( isNaN(n) ? '' : n + ' Artikel' ) +
      ( gesamt ? ' · Summe ' + gesamt.textContent.trim() : '' );
    summe.hidden = ! summe.textContent;
    hinweis.classList.remove('afp-wk-hinweis--offen');
    void hinweis.offsetWidth;
    hinweis.classList.add('afp-wk-hinweis--offen');
    clearTimeout(uhr);
    uhr = setTimeout(hinweisSchliessen, 9000);
  }

  /* Nach „In den Warenkorb“ rufen die Hersteller-Skripte (component-quick-buy.js, section-main-product.js) direkt
     nach dem Ereignis `add-to-cart` leiste.show() auf. Das Ereignis merken wir uns im Capture und fangen show() ab. */
  let originalShow = function () {};
  document.addEventListener('add-to-cart', (event) => {
    const ziel = event.target && event.target.querySelector ? event.target : null;
    // Handy: immer nur der Hinweis. PC: nur bei Käufen aus einer Weinkarte (quick-add-to-cart in Listen);
    // auf der Produktseite öffnet sich die Leiste wie gewohnt.
    const ausListe = !! ( ziel && ziel.closest && ziel.closest('quick-add-to-cart') );
    if ( ! handy.matches && ! ausListe ) return;
    vonKauf = true;
    const feld = ziel ? ziel.querySelector('input[name="id"]') : null;
    variante = feld ? feld.value : '';
    if ( ausListe && ziel ) kaufknopfBestaetigen(ziel.querySelector('[data-js-product-add-to-cart]'));
    setTimeout(() => { vonKauf = false; }, 0);
  }, true);

  /* Kaufknopf der Weinkarte zeigt kurz Häkchen (und am PC „Hinzugefügt“), danach wieder wie vorher. */
  const HAKEN = '<path d="M5 12.5l4.5 4.5L19 7.5"/>';
  function kaufknopfBestaetigen(knopf) {
    if ( ! knopf || knopf.dataset.afpOk ) return;
    const symbol = knopf.querySelector('.afp-wk__ico');
    const text = knopf.querySelector('.afp-wk__btn-text');
    const symbolAlt = symbol ? symbol.innerHTML : '';
    const textAlt = text ? text.textContent : '';
    knopf.dataset.afpOk = '1';
    knopf.classList.add('afp-wk__btn--ok');
    if ( symbol ) symbol.innerHTML = HAKEN;
    if ( text ) text.textContent = 'Hinzugefügt';
    setTimeout(() => {
      knopf.classList.remove('afp-wk__btn--ok');
      if ( symbol ) symbol.innerHTML = symbolAlt;
      if ( text ) text.textContent = textAlt;
      delete knopf.dataset.afpOk;
    }, 1800);
  }

  customElements.whenDefined('sidebar-drawer').then(() => {
    originalShow = leiste.show;
    leiste.show = function () {
      if ( vonKauf && ! leiste.classList.contains('sidebar--opened') ) {
        vonKauf = false;
        hinweisZeigen();
        return;
      }
      return originalShow.apply(leiste, arguments);
    };
  });

  /* 3) Bubble am Nach-oben-Pfeil */
  /* Nur im Shop: Kollektionen, Produktseiten, Suche. Auf Weinproben-, Hochzeits- und Infoseiten bleibt der Pfeil allein. */
  const pfeil = document.getElementById('go-top');
  const imShop = /\btemplate-(collection|product|search)\b/.test(document.body.className);
  if ( pfeil && imShop ) {
    const bubble = document.createElement('button');
    bubble.type = 'button';
    bubble.className = 'afp-wk-bubble';
    bubble.setAttribute('aria-label', 'Warenkorb öffnen');
    bubble.setAttribute('aria-controls', 'site-cart-sidebar');
    bubble.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M3 9h18l-1.6 10.2a2 2 0 0 1-2 1.8H6.6a2 2 0 0 1-2-1.8z"/><path d="M8 9l3-5M16 9l-3-5M9 13v4M15 13v4"/></svg>' +
      '<span class="afp-wk-bubble__zahl" aria-hidden="true"><span data-header-cart-count></span></span>';
    const zahl = bubble.querySelector('[data-header-cart-count]');
    const start = document.querySelector('[data-header-cart-count]');
    zahl.textContent = start ? start.textContent.trim() : '0';
    pfeil.appendChild(bubble);

    let alt = zahl.textContent;
    const pruefen = () => {
      const n = parseInt(zahl.textContent, 10) || 0;
      bubble.classList.toggle('afp-wk-bubble--leer', n < 1);
      bubble.setAttribute('aria-label', n < 1 ? 'Warenkorb öffnen' : `Warenkorb öffnen (${n} Artikel)`);
      if ( zahl.textContent !== alt ) {
        alt = zahl.textContent;
        bubble.classList.remove('afp-wk-bubble--hupf');
        void bubble.offsetWidth;
        bubble.classList.add('afp-wk-bubble--hupf');
      }
    };
    pruefen();
    new MutationObserver(pruefen).observe(zahl, { childList: true, characterData: true, subtree: true });

    bubble.addEventListener('click', (event) => {
      event.stopPropagation(); // der Pfeil darunter würde sonst nach oben scrollen
      window.lastFocusedElm = bubble;
      if ( typeof leiste.show === 'function' ) leiste.show();
    });
  }

  /* 4) Empfehlungen unten andocken (vor dem Laden des Inhalts, das Element bleibt dasselbe) */
  const empfehlungen = leiste.querySelector('cart-recommendations');
  const fuss = leiste.querySelector(':scope > .sidebar__footer');
  if ( empfehlungen && fuss ) leiste.insertBefore(empfehlungen, fuss);
})();
